import { FC, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { RecoilRoot } from 'recoil';

import { Box, Paper, Tab, Tabs } from '@mui/material';

import { TabPanel } from 'components/shared';
import StyledTabs from 'components/shared/StyledTabs';
import PeriodAssignments from 'components/shared/Assignments/PeriodAssignments';

const FlexAssignments: FC = () => {
  const [activeTab, setActiveTab] = useState<number>(0);
  const { t } = useTranslation();
  // const { hasFlexCapacityView } = useSelector((state) => state.grants);

  const onChangeActiveTab = (event, newTab) => {
    setActiveTab(newTab);
  };

  return (
    <>
      <StyledTabs>
        <Paper
          square
          sx={{
            position: 'sticky',
            top: 0,
            backgroundColor: '#FFF',
            zIndex: 40
          }}
        >
          <Tabs
            indicatorColor="primary"
            textColor="primary"
            value={activeTab}
            onChange={onChangeActiveTab}
          >
            <Tab
              label={t('flexPortalCapacity.tabs.openAssignments')}
              value={0}
            />
            <Tab
              label={t(`flexPortalCapacity.tabs.allAssignments`)}
              value={1}
            />
            {/*{hasFlexCapacityView && (*/}
            {/*  <Tab label={t(`flexPortalCapacity.tabs.capacity`)} value={2} />*/}
            {/*)}*/}
          </Tabs>
        </Paper>
        <Box p={2}>
          <TabPanel
            index={0}
            value={activeTab}
            title={t('flexPortalCapacity.tabs.openAssignments')}
          >
            <PeriodAssignments
              allowedToProcess={true}
              statuses={['REQUESTED', 'IN_PROGRESS']}
            />
          </TabPanel>
          <TabPanel
            index={1}
            value={activeTab}
            title={t('flexPortalCapacity.tabs.allAssignments')}
          >
            <PeriodAssignments allowedToProcess={true} />
          </TabPanel>
          {/*{hasFlexCapacityView && (*/}
          {/*  <TabPanel*/}
          {/*    index={2}*/}
          {/*    value={activeTab}*/}
          {/*    title={t('flexPortalCapacity.tabs.capacity')}*/}
          {/*  >*/}
          {/*    <FlexCapacityOverview />*/}
          {/*  </TabPanel>*/}
          {/*)}*/}
        </Box>
      </StyledTabs>
    </>
  );
};

export default () => (
  <RecoilRoot>
    <FlexAssignments />
  </RecoilRoot>
);
